<template>
<div>
  <!-- Site footer -->
    <footer class="site-footer">
      <div class="container">
        <div class="row">
          <div class="col-lg-6 col-sm-6 col-xs-12">
            <p class="copyright-text">Copyright <span class="copyrightName">&copy;</span> 2022  | 
            <span class="copyrightName">CosmicLabsNFT LLC</span>
            &nbsp;&nbsp;&nbsp;&nbsp;
            &nbsp;&nbsp;&nbsp;&nbsp;
            
            </p>
            
          </div>



          <div class="col-lg-6 col-sm-6 col-xs-12">
          
            <ul class="social-icons">
              <b-link href="https://twitter.com/CosmicLabsNFT" target="_blank"><b-icon icon="twitter" font-size="20" ></b-icon></b-link>
              &nbsp;
              <b-link href="https://Discord.gg/CosmicLabsNFT" target="_blank"><b-icon icon="discord" font-size="20"></b-icon></b-link>
            </ul>
          </div>
          <br><br><br>
        </div>
      </div>
</footer>
</div>
</template>

<script>
export default {
    name: "Footer",
    methods:{

    }
}
</script>

<style scoped>
.termsLink
{
  text-decoration: none !important;
  color: black !important;
}
.site-footer
{
  background-color:#4ad2ee;
  padding:45px 0 20px;
  font-size:15px;
  line-height:24px;
  color:#737373;
}
.site-footer a
{
  color: white;
}
.site-footer a:hover
{
  text-decoration:none;
}
.footer-links
{
  padding-left:0;
  list-style:none
}
.footer-links li
{
  display:block
}
.footer-links a
{
  color:#737373
}
.footer-links a:active,.footer-links a:focus,.footer-links a:hover
{
  color:#4ad2ee;
  text-decoration:none;
}
.footer-links.inline li
{
  display:inline-block
}
.site-footer .social-icons
{
  text-align:right
}
.site-footer .social-icons a
{
  width:40px;
  height:40px;
  line-height:40px;
  vertical-align: middle;
  margin-left:6px;
  margin-right:0;
  border-radius:100%;
  background-color:#33353d
}
.copyright-text
{
  margin:0;
  font-size: 2vh;
  font-weight: bold;
  color: black;
}
.copyrightName
{
  margin:0;
  font-size: 2vh;
  font-weight: bold;
  color: white;  
}
@media (max-width:991px)
{
  .site-footer [class^=col-]
  {
    margin-bottom:30px
  }
}
@media (max-width:767px)
{
  .site-footer
  {
    padding-bottom:0
  }
  .site-footer .copyright-text,.site-footer .social-icons
  {
    text-align:center
  }
}
.social-icons
{
  padding-left:0;
  margin-bottom:0;
  list-style:none
}
.social-icons li
{
  display:inline-block;
  margin-bottom:4px
}
.social-icons li.title
{
  margin-right:15px;
  text-transform:uppercase;
  color:#96a2b2;
  font-weight:700;
  font-size:13px
}
.social-icons a{
  background-color:#eceeef;
  color:white;
  font-size:16px;
  display:inline-block;
  line-height:44px;
  width:44px;
  height:44px;
  text-align:center;
  margin-right:8px;
  border-radius:100%;
  -webkit-transition:all .2s linear;
  -o-transition:all .2s linear;
  transition:all .2s linear
}
.social-icons a:active,.social-icons a:focus,.social-icons a:hover
{
  color:#fff;
  background-color:#4ad2ee;
}
.social-icons.size-sm a
{
  line-height:34px;
  height:34px;
  width:34px;
  font-size:14px
}
.social-icons a.facebook:hover
{
  background-color:#3b5998
}
.social-icons a.twitter:hover
{
  background-color:#00aced
}
.social-icons a.linkedin:hover
{
  background-color:#007bb6
}
.social-icons a.dribbble:hover
{
  background-color:#ea4c89
}
@media (max-width:767px)
{
  .social-icons li.title
  {
    display:block;
    margin-right:0;
    font-weight:600
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Navigation/Footer.vue